import { Dropdown } from 'primereact/dropdown';
import React from "react";

export const formatDateTimeTR = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);
  return date.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateTR = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);
  return date.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
};


export const formatCurrencyTRY = (value) => {
  if (value === null || value === undefined || value === '') return '';

  const numberValue = typeof value === 'number' ? value : parseFloat(value);

  if (Number.isNaN(numberValue)) return '';

  return numberValue.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


export const statusFilterTemplate = (options) => (

    <Dropdown
      value={options.value}
      options={[
        { label: 'Aktif', value: true },
        { label: 'Pasif', value: false }
      ]}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Tümü"
      className="p-column-filter"
      showClear
    />
  );

export const statusBodyTemplate = (rowData) => (
    <span
      className="badge"
      style={{
        backgroundColor: rowData.is_active ? '#2ecc71' : '#e74c3c',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '12px',
        fontSize: '0.8rem'
      }}
    >
      {rowData.is_active ? 'Aktif' : 'Pasif'}
    </span>
  );

export const imageBodyTemplate = () => (
    <img
      src="https://www.gravatar.com/avatar/?d=mp&s=50"
      alt="avatar"
      style={{ width: '32px', borderRadius: '50%' }}
    />
  );